var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dottedBox"},[_c('div',{staticClass:"dottedTitle c324 pl20 fz16"},[_vm._v("\n    "+_vm._s(_vm.dotedName)+"\n  ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }